import { render, staticRenderFns } from "./VerifyEmailSuccess.vue?vue&type=template&id=fe2c3ab6&scoped=true&"
import script from "./VerifyEmailSuccess.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2c3ab6",
  null
  
)

export default component.exports